module.exports = __webpack_public_path__ + "static/pokoj-nr5-photo04-75d3c3519052cfd52e78fc41d9ff6118.jpg";